import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ACCESS_DENIED_REDIRECT_EVENT } from '@/constants/accessDenied'

/**
 * Angular CustomHttpInterceptor: on API body `"Access Denied"`, navigate to `/dashboard`
 * without a full page reload so the Validation Message modal (document.body) stays visible.
 */
export function AccessDeniedRedirectListener() {
  const navigate = useNavigate()

  useEffect(() => {
    const onAccessDenied = () => {
      const path = window.location.pathname
      if (path === '/dashboard' || path === '/dashboard/') return
      navigate('/dashboard', { replace: true })
    }
    window.addEventListener(ACCESS_DENIED_REDIRECT_EVENT, onAccessDenied)
    return () => window.removeEventListener(ACCESS_DENIED_REDIRECT_EVENT, onAccessDenied)
  }, [navigate])

  return null
}
